import { Reducer } from "redux"
import { Action } from "../types"

interface KolQueryState {
  kolQuery: any
}

const initialState: KolQueryState = {
  kolQuery: {},
}

const kolQueryReducer: Reducer<KolQueryState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case "SET_KOL_QUERY":
      return {
        ...state,
        kolQuery: action.payload,
      }
    default:
      return state
  }
}

export { kolQueryReducer }
